import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { SchedForm } from './SchedForm';

export const SchedDetail = () => {

  const tabSpecs = [{ id: 'infoTab', label: 'Info', content: <SchedForm /> }];
  
  return (
    <EntityDetail tabSpecs={tabSpecs} />
  )
}